import "./global.css";

import { lazy, Suspense, type ComponentType } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Routes, Route } from "react-router-dom";
import { SupportButton } from "@/components/SupportButton";
import { ScrollToTop } from "@/components/ScrollToTop";
import { PageViewTracker } from "@/components/PageViewTracker";
import { PageLoadingFallback } from "@/components/PageLoadingFallback";
import { StagingGate } from "@/components/StagingGate";
// MintDebugPanel is only loaded in development mode
const MintDebugPanel: ComponentType = import.meta.env.DEV
  ? lazy(() => import("@/components/MintDebugPanel").then(m => ({ default: m.MintDebugPanel })))
  : () => null;

// Route-level code splitting for better initial load performance
const Index = lazy(() => import("./pages/Index"));
const Whitepaper = lazy(() => import("./pages/Whitepaper"));
const ChoosePortfolio = lazy(() => import("./pages/ChoosePortfolio"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const NotFound = lazy(() => import("./pages/NotFound"));

const App = () => (
  <StagingGate>
  <TooltipProvider>
    <Toaster />
    <Sonner />
    <ScrollToTop />
    <PageViewTracker />
    <Suspense fallback={null}><MintDebugPanel /></Suspense>
    <Suspense fallback={<PageLoadingFallback />}>
      <Routes>
        {/* Main app routes */}
        <Route path="/" element={<ChoosePortfolio />} />
        <Route path="/whitepaper" element={<Whitepaper />} />
        <Route path="/portfolios" element={<ChoosePortfolio />} />
        <Route path="/portfolios/:portfolioId" element={<Index />} />
        {/* Dashboard routes */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/*" element={<Dashboard />} />

        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
    <SupportButton />
  </TooltipProvider>
  </StagingGate>
);

export default App;
